import React from "react";
import LandPage from "../pages/LandPage/LandPage";
import Prizes from "../pages/Prizes/Prizes";
import Login from "../pages/Login/Login";
import Objectives from "../pages/Objectives/Objectives";
import PrizeStats from "../pages/Stats/PrizeStats";
import ObjectiveStats from "../pages/Stats/ObjectiveStats";
import UserStats from "../pages/Stats/UserStats";
import UserList from "../pages/Stats/UserList";
import VerifyCode from "../pages/Verifycode/VerifyCode";
import {PolicyComponent} from "../components/Policy/policy";
import {PolicyComponent3} from "../components/Policy/policy3";
import LoadingPage from "../pages/LoadingPage/LoadingPage";
import LiveMap from "../pages/LiveMap/livemap";


export const nav = [
  {
    path: "/",
    name: "Home",
    element: <LandPage />,
    isMenu: true,
    isPrivate: false,
  },
  {
    path: "/prize",
    name: "Prizes",
    element: <Prizes />,
    isMenu: true,
    isPrivate: true,
  },
  {
    path: "/login",
    name: "Login",
    element: <Login />,
    isMenu: false,
    isPrivate: false,
  },

  {
    path: "/liveMap",
    name: "LiveMap",
    element: <LiveMap />,
    isMenu: true,
    isPrivate: false,
  },
  {
    path: "/objectives",
    name: "Objectives",
    element: <Objectives />,
    isMenu: true,
    isPrivate: true,
  },
  {
     path: "/prize-stats",
     name: "PrizeStats",
     element: <PrizeStats />,
     isMenu: false,
     isPrivate: true,
  },
  {
    path: "/objective-stats",
    name: "ObjectiveStats",
    element: <ObjectiveStats />,
    isMenu: false,
    isPrivate: true,
  },
  {
    path: "/user-stats",
    name: "UserStats",
    element: <UserStats />,
    isMenu: false,
    isPrivate: true,
  },

  {
    path: "/add_admin",
    name: "UserList",
    element: <UserList />,
    isMenu: false,
    isPrivate: true,
  },

  {
    path: "/verify-code",
    name: "VerifyCode",
    element: <VerifyCode />,
    isMenu: false,
    isPrivate: true,
  },
  {
    path: "/policy",
    name: "Policy",
    element: <PolicyComponent />,
    isMenu: false,
    isPrivate: false,
  },

  {
    path: "/policy_zenu",
    name: "Policy_zenu",
    element: <PolicyComponent3 />,
    isMenu: false,
    isPrivate: false,
  }
];